export function extractContentId(initData) {
  // MC: layout is [4 byte: linkLength][linkLength byte: link]
  const linkDataLen = new DataView(initData.slice(0, 4).buffer).getUint32(
    0,
    true
  );
  const link = String.fromCharCode.apply(
    null,
    new Uint16Array(initData.slice(4, linkDataLen + 4).buffer)
  );
  // MC: link is string like 'skd://<hex_asset_id>'
  const contentIdHex = new URL(link).hostname;
  const contentIdArray = [];
  for (let c = 0; c < contentIdHex.length; c += 2) {
    contentIdArray.push(parseInt(contentIdHex.substr(c, 2), 16));
  }
  const contentId = Uint8Array.from(contentIdArray);
  // MC: FairPlay EME requires contentId be a string with Base64-encoded ID bytes
  return base64EncodeUint8Array(contentId);
}

export function concatInitDataIdAndCertificate(initData, id, cert) {
  if (typeof id == 'string') {
    id = stringToArray(id);
  }
  // layout is [initData][4 byte: idLength][idLength byte: id][4 byte:certLength][certLength byte: cert]
  let offset = 0;
  const buffer = new ArrayBuffer(
    initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength
  );
  const dataView = new DataView(buffer);

  const initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
  initDataArray.set(initData);
  offset += initData.byteLength;

  dataView.setUint32(offset, id.byteLength, true);
  offset += 4;

  const idArray = new Uint16Array(buffer, offset, id.length);
  idArray.set(id);
  offset += idArray.byteLength;

  dataView.setUint32(offset, cert.byteLength, true);
  offset += 4;

  const certArray = new Uint8Array(buffer, offset, cert.byteLength);
  certArray.set(cert);

  return new Uint8Array(buffer, 0, buffer.byteLength);
}

export function getRefFromSrc(src) {
  let ref = '';
  if (src) {
    const phrase = '.biz';
    const index = src.indexOf(phrase);
    if (index !== -1) {
      ref = src.substr(index + phrase.length);
    }
  }
  return ref;
}

function stringToArray(string) {
  const buffer = new ArrayBuffer(string.length * 2); // 2 bytes for each char
  const array = new Uint16Array(buffer);
  for (let i = 0, strLen = string.length; i < strLen; ++i) {
    array[i] = string.charCodeAt(i);
  }
  return array;
}

function base64EncodeUint8Array(input) {
  const keyStr =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  let output = '';
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;

  while (i < input.length) {
    chr1 = input[i++];
    chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index
    chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output +=
      keyStr.charAt(enc1) +
      keyStr.charAt(enc2) +
      keyStr.charAt(enc3) +
      keyStr.charAt(enc4);
  }
  return output;
}
